import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
Vue.use(VueAxios, axios,Vuesax)
if (!Vue.moment) {
    Vue.use(VueMoment)
  }
export const userKey = '___knowledge__admin'
export const userKeyT = '___knowledge__adminToken'

export const clientKey = '_client__knowledge'
export const clientKeyT = '___knowledge__clientToken'
export const gapeKeyT = '___knowledge__gapeToken'
export const gapeKey = '_gape__knowledge'

export const autoKeyT = '___knowledge__autoToken'
export const autoKey = '_auto__knowledge'

export const contrataServico = '___knowledge__contrataServico'
export const rota = '___knowledge__rota'

export const urlApi = process.env.NODE_ENV === "development" ? 'https://localhost:44324/' : 'https://jeanpierre.webapp.com.br/webapi/'

export function getError(e){
    console.log(e.response.status)
}
export function showError(e){
    console.log(e.response.status)
}
async function get_data(value){
    let data= [];
    const response = await axios.get(value).then(response => {
        data.push({
            status:response.status, 
            content:response.data
        })
        return data;
    }).catch( () => {}); 
    return response
}

async function delete_data(valueUrl,valueId,valueData, valueAtivo){
    let data= [];
    let config = {
        method: 'put',
        url: valueUrl + valueId,
        data:{
            [valueData]:valueId,
            tsAlteracao: Vue.$mome
        }
    }
    console.log(valueAtivo)
    const response = await axios(config)
    .then(response => {
        data.push({
            content:response.data
        })
        Vue.toasted.global.defaultSuccess({msg: valueAtivo ? 'Item inativado com sucesso!' : 'Item ativado com sucesso'})
        return data;
    }).catch(() => {}); 
    return response
}

export function getData(value){
    return  get_data(value);
}
export function deleteData(valueUrl,valueId,valueData,valueAtivo){
    return  delete_data(valueUrl,valueId,valueData,valueAtivo);
}
export function getSuccess(){
    Vue.toasted.global.defaultSuccess()
}
export function formatPrice(value){
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}
function convertToken(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}
export function userClient(){
    var client = convertToken(localStorage.getItem(clientKey))
    let dadosObj = JSON.stringify(client);
    let dadosJson = JSON.parse(dadosObj);
    return dadosJson
}
export function validarCPF(cpf){
  cpf = cpf.replace(/[^\d]+/g,'');	
	if(cpf == '') return false;	
	// Elimina CPFs invalidos conhecidos	
	if (cpf.length != 11 || 
		cpf == "00000000000" || 
		cpf == "11111111111" || 
		cpf == "22222222222" || 
		cpf == "33333333333" || 
		cpf == "44444444444" || 
		cpf == "55555555555" || 
		cpf == "66666666666" || 
		cpf == "77777777777" || 
		cpf == "88888888888" || 
		cpf == "99999999999")
			return false;		
	// Valida 1o digito	
	var add = 0;	
  var rev = 0;
  var i = 0
	for (i=0; i < 9; i ++)		
		add += parseInt(cpf.charAt(i)) * (10 - i);	
		rev = 11 - (add % 11);	
		if (rev == 10 || rev == 11)		
			rev = 0;	
		if (rev != parseInt(cpf.charAt(9)))		
			return false;		
	// Valida 2o digito	
	add = 0;	
	for (i = 0; i < 10; i ++)		
		add += parseInt(cpf.charAt(i)) * (11 - i);	
	rev = 11 - (add % 11);	
	if (rev == 10 || rev == 11)	
		rev = 0;	
	if (rev != parseInt(cpf.charAt(10)))
		return false;		
	return true;   
}
export function validarCNPJ(cnpj){
  cnpj = cnpj.replace(/[^\d]+/g,'');
 
  if(cnpj == '') return false;
   
  if (cnpj.length != 14)
      return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" || 
      cnpj == "11111111111111" || 
      cnpj == "22222222222222" || 
      cnpj == "33333333333333" || 
      cnpj == "44444444444444" || 
      cnpj == "55555555555555" || 
      cnpj == "66666666666666" || 
      cnpj == "77777777777777" || 
      cnpj == "88888888888888" || 
      cnpj == "99999999999999")
      return false;
       
  // Valida DVs
  var i = 0;
  var resultado = 0;
  var tamanho = cnpj.length - 2
  var numeros = cnpj.substring(0,tamanho);
  var digitos = cnpj.substring(tamanho);
  var soma = 0;
  var pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
      return false;
       
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
          pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
        return false;
         
  return true; 
}
export default {
                userKey, userKeyT, clientKey,  gapeKey, getSuccess,
                deleteData,getData,getError, showError,formatPrice,
                contrataServico,userClient, urlApi,validarCPF, validarCNPJ
               }